enum MerchantSearchType {
  domain = "DOMAIN",
  name = "NAME",
  brand = "BRAND",
}

export default MerchantSearchType;
